import { render, staticRenderFns } from "./TableColumnKpoNumber.vue?vue&type=template&id=e873f284&"
import script from "./TableColumnKpoNumber.vue?vue&type=script&lang=js&"
export * from "./TableColumnKpoNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports